import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Button, Icon } from '@ibk/shared-ui';
import styles from '../SpreadsheetImportModal.module.css';
function formatFileSize(sizeInBytes) {
    if (sizeInBytes < 1024) {
        return `${sizeInBytes} B`;
    }
    const sizeInKB = sizeInBytes / 1024;
    if (sizeInKB < 1024) {
        return `${sizeInKB.toFixed(1)} KB`;
    }
    const sizeInMB = sizeInKB / 1024;
    return `${sizeInMB.toFixed(1)} MB`;
}
function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}
export function FileLoadedView({ fileName, fileSize, uploadDate, onImport, onRemoveFile }) {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.fileLoadedContainer, "data-testid": 'viewSpreadsheetImportFileLoaded', children: [_jsx("p", { className: styles.fileLoadedDescription, children: t('spreadsheet.import.file-loaded.description') }), _jsxs("div", { className: styles.fileCard, children: [_jsxs("div", { className: styles.fileCardInfo, children: [_jsxs("div", { className: styles.fileCardNameRow, children: [_jsx("span", { className: styles.fileCardName, children: fileName }), _jsx("span", { className: styles.fileCardSize, children: formatFileSize(fileSize) })] }), _jsx("span", { className: styles.fileCardDate, children: t('spreadsheet.import.file-loaded.upload-date', { date: formatDate(uploadDate) }) })] }), _jsx("button", { type: 'button', className: styles.fileCardRemove, onClick: onRemoveFile, "data-testid": 'buttonSpreadsheetImportRemoveFile', children: _jsx(Icon, { name: 'trash', variant: 'mask', tintColor: 'var(--text-neutral-dark)' }) })] }), _jsx("div", { className: styles.fileLoadedActions, children: _jsx(Button, { variant: 'primary', size: 'medium', dataTestId: 'buttonSpreadsheetImportImport', onClick: onImport, children: t('spreadsheet.import.file-loaded.import-button') }) })] }));
}
